import { Injectable } from '@angular/core';

/*
* Parse video transcript
*/
@Injectable({
  providedIn: 'root'
})
export class BrightcoveTranscriptService {
  private static readonly regexTime: RegExp = /\d\d:\d\d\.\d\d\d\s+-->\s+\d\d:\d\d\.\d\d\d.*\n/ig;
  private static readonly nonBreakingSpace: RegExp = /&nbsp;/g;

  parse(transcript: string): string {
    transcript = transcript.replace(BrightcoveTranscriptService.regexTime, '');
    // break the data into an array of lines
    const dataLines = transcript.split('\n\n');
    // remove one line, starting at the first position
    dataLines.splice(0, 1);
    // join the array back into a single string
    transcript = dataLines.join(' ');
    // replace remaining line breaks in transcript
    transcript = transcript.replace(/\n/g, ' ');
    // replace remaining non-breaking spaces in transcript
    transcript = transcript.replace(BrightcoveTranscriptService.nonBreakingSpace, ' ');
    return transcript;
  }
}
